module.exports = __webpack_public_path__ + "882756e00b99b506073746fb88614a04.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./src/font/OpenSans-Bold.woff
 ** module id = 1224
 ** module chunks = 9
 **/